<template>
  <section class="section-referral content-padding">
    <template v-if="!state.isFetching">
      <template v-if="order">
        <div class="row mt-3">
          <div class="col-md-12 text-center">
            <h3 class="title">
              {{ order.professional_name | firstName }}
              {{ $t('message.revise_datetime.title') }} #{{ order.order_code }}
            </h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 offset-lg-3">
            <div class="card">
              <div class="card-body">
                <ul class="list-unstyled cleaner-detail-list">
                  <li>
                    <div class="d-flex">
                      <div>
                        <label>{{ $t('message.my_reservations.cleaning_date') }}</label>:
                      </div>
                      <div class="pl-2">
                        <template v-if="order.revise_datetime_data">
                          <div class="mb-3">
                            <span class="strike text-secondary">{{ order.cleaning_date | prettyDate }}</span><br>
                            <span class="text-info">{{ order.revise_datetime_data.cleaning_date | prettyDate }}</span>
                          </div>
                        </template>
                        <template v-else>
                          <span class="text-info">{{ order.cleaning_date | prettyDate }}</span>
                        </template>
                      </div>
                    </div>
                  </li>
                  <li>
                    <label>{{ $t('message.my_reservations.booking') }}</label>: #{{ order.order_code }}
                  </li>
                  <li>
                    <label>{{ $t('message.my_reservations.customer_name') }}</label>:
                    {{ order.customer_name }}
                  </li>
                </ul>
                <template v-if="order.revise_datetime_data">
                  <template v-if="!isConfirmingReviseDateTime">
                    <hr>
                    <div class="mt-4">
                      <h4 class="text-center mb-4">{{ $t('message.revise_datetime.confirm_to_proceed') }}</h4>
                      <div class="pb-3">
                        <button class="btn btn-info btn-block" @click="acceptReviseDateTime">
                          {{ $t('message.revise_datetime.accept') }}
                        </button>
                      </div>
                      <div>
                        <button class="btn btn-outline-info btn-block" @click="declineReviseDateTime">
                          {{ $t('message.revise_datetime.decline') }}
                        </button>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-center" v-if="order.revise_datetime_data">
                      <hr>
                      <img src="/static/img/ring.gif" width="40"> {{ $t('message.processing') }}
                    </div>
                    <template v-else>
                      <i class="fas fa-check-circle -status-accepted"></i>
                      {{ $t('message.revise_datetime.confirmed_new_cleaning_datetime') }}
                    </template>
                  </template>
                </template>
                <template v-else>
                  <i class="fas fa-check-circle -status-accepted"></i>
                  {{ $t('message.revise_datetime.confirmed_new_cleaning_datetime') }}
                </template>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-start align-items-center">
                  <div>
                    <router-link tag="a" :to="'/cleaner/'+order.professional_id">
                      <img v-lazy="order.professional_picture"
                           alt="'BeNeat Cleaner"
                           class="img-fluid rounded-circle" width="60">
                    </router-link>
                  </div>
                  <div class="pl-3">
                    <label>{{ $t('message.my_reservations.cleaner_name') }}</label>
                    <div>
                      <router-link class="no-style" :to="'/cleaner/'+order.professional_id">
                        {{ order.professional_name | firstName }}
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="text-center">
          <h3>{{ $t('message.no_data') }}</h3>
        </div>
      </template>
    </template>
    <template v-else>
      <loader></loader>
    </template>
  </section>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import Loader from '../loader/Loader.vue'
  import MyCleaner from './components/MyCleaner.vue'

  export default {
    components: {
      Loader,
      MyCleaner
    },
    data () {
      return {
        orderId: this.$route.query.id,
        validation: this.$route.query.validation,
        hideCloseButton: true,
        performProceeding: false,
        proceedingMessage: ''
      }
    },
    computed: {
      ...mapGetters({
        isConfirmingReviseDateTime: 'orderDetail/getIsConfirmReviseDateTime',
        globalState: 'globalVal/getState',
        order: 'orderDetail/getOrderDetail',
        state: 'orderDetail/getState',
        user: 'auth/getUser'
      })
    },
    watch: {
      isConfirmingReviseDateTime () {
        if (!this.state.isConfirmingReviseDateTime) {
          // Revise date time data to be null
          this.$store.commit('orderDetail/SET_ORDER_REVISE_DATE_TIME', null)
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getToken']),
      ...mapActions('orderDetail', ['loadOrderDetail']),
      async fetchOrderDetail () {
        if (this.user) {
          await this.loadOrderDetail(this.orderId)
        } else {
          const submitData = {
            order_id: this.orderId,
            validation: this.validation
          }
          await this.getToken(submitData)
          await this.loadOrderDetail(this.orderId)
        }
      },
      acceptReviseDateTime () {
        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: this.$i18n.t('message.confirm.accept_revise_datetime'),
          type: 'info',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(() => {
          this.confirmOrderReviseDateTime('accept')
        })
      },
      declineReviseDateTime () {
        this.$swal({
          title: this.$i18n.t('message.confirm.title'),
          text: this.$i18n.t('message.confirm.decline_revise_datetime'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          reverseButtons: true,
          confirmButtonText: this.$i18n.t('message.confirm.yes'),
          cancelButtonText: this.$i18n.t('message.confirm.no')
        }).then(() => {
          this.confirmOrderReviseDateTime('decline')
        })
      },
      confirmOrderReviseDateTime (confirmAction) {
        let submitData = null
        if (this.user) {
          submitData = {
            order_id: this.orderId,
            user_id: this.user.id,
            validation: '',
            confirm_action: confirmAction
          }
        } else {
          submitData = {
            order_id: this.orderId,
            user_id: 0,
            validation: this.validation,
            confirm_action: confirmAction
          }
        }
        this.$store.dispatch('orderDetail/CONFIRM_REVISE_DATE_TIME', submitData)
      }
    },
    mounted () {
      if (this.user) {
        this.$router.push('/reservation/' + this.orderId)
      } else {
        this.fetchOrderDetail()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/ConfirmOrderReviseDateTime.vue